import routerOptions0 from "/home/runner/work/jadoo/jadoo/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  sensitive: true,
  strict: false,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}